import { styled, useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo } from 'react';

const Root = styled('div')(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  minWidth: 15,
  height: 18,
  borderRadius: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 6px',
  color: theme.palette.secondary.contrastText,
}));

function FuseNavBadge(props) {
  const { className, badge } = props;
  const theme = useTheme();

  if (badge.title === 0 || badge.title == null) {
    return null;
  }

  if (badge.title === '') {
    return (
      <div
        className={clsx('item-badge', className, badge?.classes)}
        style={{
          backgroundColor: badge.bg || 'red',
          width: 7,
          height: 7,
          borderRadius: '100%',
          marginRight: '10px',
        }}
      />
    );
  }

  return (
    <Root
      className={clsx('item-badge', className, badge?.classes)}
      style={{
        backgroundColor: badge.bg || 'red',
        color: badge.fg || theme.palette.secondary.contrastText,
      }}
    >
      {badge.title}
    </Root>
  );
}

FuseNavBadge.propTypes = {
  badge: PropTypes.shape({
    title: PropTypes.node,
    bg: PropTypes.string,
    fg: PropTypes.string,
  }),
};

export default memo(FuseNavBadge);
